import * as yup from "yup"
import { FieldDefinition } from "../types"

const stringField = (field: FieldDefinition) => {
  let fieldSchema = yup.string()
  if (field.required) {
    fieldSchema = fieldSchema.required()
  }
  return fieldSchema
}

const emailField = (field: FieldDefinition) => {
  let fieldSchema = yup.string().email()
  if (field.required) {
    fieldSchema = fieldSchema.required()
  }
  return fieldSchema
}

const getFieldValidator = (field: FieldDefinition) => {
  switch (field.type) {
    case "text":
      return stringField(field)
    case "textArea":
      return stringField(field)
    case "email":
      return emailField(field)
    default:
      return yup.mixed()
  }
}

export const createSchema = (fields: FieldDefinition[]) =>
  yup.object().shape(
    fields.reduce((acc, field) => {
      acc[field.name] = getFieldValidator(field)
      return acc
    }, {} as { [key: string]: any })
  )
